import React, { useContext } from 'react';
import { useState } from 'react';
import { Project, StateContext } from '../../../StateContext';
import { addToDoListCall } from '../../../Services/APICalls/apicalls';
import { Modal, Box, TextField } from '@mui/material';
import { boxStyle } from '../styles';
import { IContextData } from '../../../../App';
import { useLanguage } from '../../../Services/LanguageContext';

interface IProps {
    project: Project;
}

const AddToDo = (props: IProps) => {
    const { loginData, setLoginData } = useContext<IContextData>(StateContext);
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const { t } = useLanguage();

    const addToDoHandler = () => {
        addToDoListCall(props.project.id, title, setLoginData);
        setOpen(false);
        setTitle('');
        return;
    };

    return (
        <React.Fragment>
            <button onClick={() => setOpen(true)}>{t('addItem')}</button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box style={boxStyle as any}>
                    <form
                        onSubmit={addToDoHandler}
                        action='#'
                        className='flex flex-col items-center gap-3'
                    >
                        <TextField
                            type='text'
                            label={t('afterSalesItem')}
                            value={title}
                            onClick={(x) => {
                                x.stopPropagation();
                            }}
                            onChange={(x) => setTitle(x.target.value)}
                        ></TextField>
                        <button>{t('save')}</button>
                    </form>
                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default AddToDo;
